import { TFunction } from 'i18next'
import { ChatMessage } from './chat'

export const initialGeneratingMessages = (isDone: boolean, t: TFunction): Array<ChatMessage> => [
	{
		id: 'bot-1',
		type: 'bot',
		content: t('editor.placeholders.greeting'),
	},
	{
		id: 'bot-2',
		type: 'bot',
		content: t('editor.placeholders.newCampaign'),
	},
	{
		id: 'bot-3',
		type: 'loader',
		doneContent: t('editor.placeholders.dataReady'),
		contents: [
			t('editor.placeholders.preparingCampaign'),
			t('editor.placeholders.initializingData'),
			t('editor.placeholders.gatheringInformation'),
		],
		state: isDone ? 'done' : 'pending',
	},
]
